import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetCoursesByTermId = (termId, options = {}) => {
  return useApiQuery(
    ['courses-by-term', termId],
    'schools',
    `/terms/${termId}/courses?limit=500`,
    {
      enabled: !!termId && options.enabled !== false,
      staleTime: 1000 * 60 * 10,
      ...options
    },
    { authenticated: true, version: 3 }
  )
}
